/**
 * Shift-register query keys.
 *
 * `register` is keyed on the **whole filter object**, page included — every
 * field of it changes which rows come back, and having the page in the key is
 * what lets `keepPreviousData` hold page 1 on screen while page 2 loads rather
 * than blanking the register between them.
 *
 * `ledgerSummary` carries the **locale** as well as the shift, because the
 * account names on the rollup are resolved server-side: switching language is a
 * different answer, not a stale one. Same reason the operations activity detail
 * key carries it.
 */
export const ShiftsQueryKeys = {
    all: ['shifts'] as const,
    register: (filters: unknown) =>
        [...ShiftsQueryKeys.all, 'register', filters] as const,
    ledgerSummary: (shiftId: string, locale: string) =>
        [...ShiftsQueryKeys.all, 'ledger-summary', shiftId, locale] as const,
};
